export default __webpack_public_path__ + "static/media/GoldFrame03.54cefd76.png";